import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Loader from "../Components/Loader";
import { baseUrl } from "../Common/data";
import useWishlist from "../hooks/useWishlist";

function PropertyCollectionDetail() {
  const { collectionId } = useParams();
  const navigate = useNavigate();

  const [collectionName, setCollectionName] = useState("");
  const [properties, setProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const { isInWishlist, toggleWishlist } = useWishlist();

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/property-collection/${collectionId}`,
        );
        if (response.status === 200 && response.data?.data) {
          const collection = response.data.data;
          setCollectionName(collection.name);
          setProperties(collection.properties || []);
          setFilteredProperties(collection.properties || []);
        }
      } catch (err) {
        setError("Failed to fetch collection details.");
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCollection();
  }, [collectionId]);

  useEffect(() => {
    if (searchQuery) {
      const filtered = properties.filter(
        (property) =>
          property.propertyName
            ?.toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          property.city?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          property.state?.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      setFilteredProperties(filtered);
    } else {
      setFilteredProperties(properties);
    }
  }, [searchQuery, properties]);

  const handleCardClick = (id) => {
    window.open(`/collectiondetail/${id}`, "_blank");
  };

  const handleWishlistClick = async (e, id) => {
    e.stopPropagation();
    const token = localStorage.getItem("token");
    if (!token) return alert("Please login to use wishlist.");
    await toggleWishlist(id);
  };

  return (
    <>
      <Navbar />

      <div className="col-banner col-banner2">
        <div className="search-bar search-bar2">
          <h2>{collectionName || "Collection"}</h2>
          <div className="search-bar-div">
            <input
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search Property"
            />
            <i className="bi bi-search"></i>
          </div>
        </div>
      </div>

      {isLoading ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : error ? (
        <p style={{ color: "red", textAlign: "center" }}>{error}</p>
      ) : (
        <div className="trending-cards2 trending-cards3">
          <div className="az">
            {filteredProperties.length === 0 ? (
              <p
                style={{ textAlign: "center", width: "100%", padding: "40px" }}
              >
                No properties found in this collection.
              </p>
            ) : (
              filteredProperties.map((property) => (
                <div
                  key={property._id}
                  className="trending-card trending-card2"
                  onClick={() => handleCardClick(property._id)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="wishlist-icon"
                    onClick={(e) => handleWishlistClick(e, property._id)}
                  >
                    <i
                      className={
                        isInWishlist(property._id)
                          ? "bi bi-heart-fill"
                          : "bi bi-heart"
                      }
                    ></i>
                  </div>

                  <img
                    src={property.images?.profile}
                    alt={property.propertyName}
                  />

                  <div className="trending-text">
                    <h3>{property.propertyName}</h3>
                    <div className="trending-text-line">
                      <p>
                        <i className="bi bi-geo-alt-fill"></i> {property.city},{" "}
                        {property.state}
                      </p>
                    </div>
                    <div className="trending-text-line2">
                      <p>
                        {property?.guestCapacity} Guest ✦ {property?.totalRooms}{" "}
                        {property?.totalRoomsType === "beds" ? "Beds" : "Rooms"}{" "}
                        ✦ {property?.poolSize?.length} X{" "}
                        {property?.poolSize?.breadth} Pool
                      </p>
                    </div>
                    <div className="trending-text-line">
                      <h2>
                        ₹ {property?.listingprice}{" "}
                        <span>
                          /{" "}
                          {property?.priceType === "per_person"
                            ? "Person"
                            : "Night"}
                        </span>
                      </h2>
                      <button>Book Now</button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default PropertyCollectionDetail;
